import { useEffect, useRef } from 'react';

const CALENDLY_ORIGIN = 'https://calendly.com';

export interface SchedulingEvent {
  eventUri?: string;
  inviteeUri?: string;
}

interface SchedulingWidgetProps {
  embedUrl: string;
  onEventScheduled: (event: SchedulingEvent) => void;
  title?: string;
}

export function SchedulingWidget({
  embedUrl,
  onEventScheduled,
  title = 'Schedule a time',
}: SchedulingWidgetProps) {
  const onScheduledRef = useRef(onEventScheduled);
  useEffect(() => {
    onScheduledRef.current = onEventScheduled;
  });

  useEffect(() => {
    const handle = (event: MessageEvent) => {
      if (event.origin !== CALENDLY_ORIGIN) return;
      if (event.data?.event !== 'calendly.event_scheduled') return;

      const payload = event.data?.payload;
      onScheduledRef.current({
        eventUri: payload?.event?.uri,
        inviteeUri: payload?.invitee?.uri,
      });
    };

    window.addEventListener('message', handle);
    return () => window.removeEventListener('message', handle);
  }, []);

  let src = embedUrl;
  try {
    const url = new URL(embedUrl);
    url.searchParams.set('embed_domain', window.location.host);
    url.searchParams.set('embed_type', 'Inline');
    url.searchParams.set('background_color', 'ffffff');
    url.searchParams.set('primary_color', 'ba9965');
    url.searchParams.set('hide_gdpr_banner', '1');
    src = url.toString();
  } catch {
    // Leave src as-is if embedUrl isn't a valid absolute URL.
  }

  return (
    <iframe
      src={src}
      title={title}
      className="w-full rounded-lg"
      style={{ height: 'clamp(630px, 72svh, 800px)', border: 'none' }}
    />
  );
}
